import React from 'react'
import {BaseInputParams} from './BaseInput'

export default ({error}: Pick<BaseInputParams, 'error'>) => error
    ? <small style={{backgroundColor: 'rgba(255,56,80,0.4)'}}>{error}</small>
    : null